<style>
    .slider-btn .slider-btn-left .slider-btn-right  {
        background: none !important
    }
    

    .slide-struct {
        text-align: justify;
        height: calc(100vh);
        width: 80% !important;
        background: none !important;
        margin: 40px 60px 150px 60px !important;
    }

    
    @media only screen and (max-width: 480px) {
        .slide-struct {            
            margin: 0px;
            width: 100%;            
        }
        #imgAtuacao {
            width: calc(100vw);
        }
    }
</style>

<template>
    <slider animation="fade" :autoplay="false" height="calc(80vh)" :control-btn="false" :touch="true" class="slide-struct">
        <slider-item v-for="(i, index) in atuacao" :key="index" style="background: none !important;"> 
            <v-layout layout column wrap align-center justify-space-between>
                <v-flex>
                    <v-img v-if="i.logo" width="calc(30vh)" height="calc(30vh)" :src="i.logo"></v-img>
                    <v-icon v-if="i.icon" class="white--text" style="font-size: 100px">{{i.icon}}</v-icon>
                </v-flex>
                <v-flex>
                    <p style="line-height: 80px; font-size: 2.6rem; text-align: center;">{{i.title}}</p>
                </v-flex>
                <v-flex>
                    <p style="text-align: justify">
                        {{i.description}}
                    </p>
                </v-flex>
            </v-layout>            
        </slider-item>
    </slider>
</template>

<script>
/* eslint-disable */

import { Slider, SliderItem } from 'vue-easy-slider'


export default {
  components: {
    Slider,
    SliderItem,
  },
  name: 'v-atuacao',
  data () {
    return {
        index: 0,
        autoInterval: true,
        atuacao: [{
            title: 'DESENVOLVIMENTO',
            description: 'Trabalhamos com desenvolvimento de aplicativos e plataformas web, android e iOS. Além disso, somos especialistas em desenvolvimento de aplicativos para G Suite e Chrome Store.',
            // icon: 'settings',
            logo: 'static/gear.png'
        },
        {
            title: 'MIGRAÇÃO',
            description: ' Possuímos uma equipe certificada que nos habilita a migrar seus dados e aplicativos para a nuvem com segurança e agilidade.',
            logo: 'static/cloud-migrate.png',
        },
        {
            title: 'CONSULTORIA',
            description: ' Prestamos consultoria técnica para seu negócio, analisamos em qual passo da transformação digital seu negócio está e analisamos como as tecnologias no mercado podem agregar valor, trazer resultados e eficiência para você.',
            logo: 'static/together.png',
        }],
        list: [
            { backgroundColor: '#3f51b5', width: '100%', height: '100%' },
            { backgroundColor: '#eee', width: '100%', height: '100%' },
            { backgroundColor: '#f44336', width: '100%', height: '100%' },
        ],
    }
  },
  methods: {
      changeIndex (e) {
          this.autoInterval = false;
          console.log(e.target.class);
      }
  },
  mounted () {      
      setInterval(() => {
          if (this.autoInterval) {
            this.index = (this.index == 2) ? 0 : (this.index + 1)
          }
      }, 2000);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Atuacao.vue